









import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import { Prop } from 'vue-property-decorator'
import ItemStepByIcon from '@/modules/base-campaign-item/components/shared/StepCheckByIcon.vue'
import TesTd from '@/modules/common/tes-table/components/shared/TesTd.vue'

@Component({
  components: { TesTd, ItemStepByIcon }
})
export default class StepTableCell extends Vue {
  @Prop() value!: number
  @Prop() row!: any
  @Prop() props!: any
  @Prop() grid!: boolean
}
